
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.809.293a1.218 1.218 0 011.584 0l4.478 4a.928.928 0 010 1.416c-.437.39-1.147.39-1.585 0L9.72 3.415V15c0 .553-.5 1-1.12 1-.619 0-1.12-.447-1.12-1V3.415L4.913 5.709c-.437.39-1.148.39-1.585 0a.928.928 0 010-1.416l4.478-4h.004z","fill":"#313131"}})])
          )
        }
      }
    